import { Route, Routes } from 'react-router-dom'
import LoginPage from "./screens/login";
import Home from './screens/home';
import ChecklistSubmit from './screens/checklist';
import History from './screens/history';
import SubmissionDetail from './screens/submission';
import PrivacyPolicy from './screens/privacy-policy';
import ProtectedRoutes from './ProtectedRoutes';
import SplashScreen from './screens/SplashScreen';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<SplashScreen />} />
            <Route path='/splash' element={<SplashScreen />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />

            <Route element={<ProtectedRoutes />}>
                <Route path='/home' element={<Home />} />
                <Route path='/checklist' element={<ChecklistSubmit />} />
                <Route path='/history' element={<History />} />
                <Route path='/history/:id' element={<SubmissionDetail />} />
            </Route>
        </Routes>
    )
}

export default AppRoutes;
